import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Router WAJIB di sini
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // HAPUS React.StrictMode (Penyebab Grafik Error)
  // GUNAKAN BrowserRouter (Penyebab Navigasi Jalan)
  <BrowserRouter>
    <App />
  </BrowserRouter>
);